import {
  Box,
  Button,
  FormControl,
  TextField,
  Autocomplete,
} from "@mui/material";
import { useState } from "react";
import { trpc } from "#next/utils/trpc";

export const UserSearch = () => {
  const [searchedUsername, setSearchedUsername] = useState<string | null>(null);
  const [searchedPlatform, setSearchedPlatform] = useState<string>("All");

  const { data: platforms } = trpc.platforms.listAll.useQuery(undefined, {
    refetchOnWindowFocus: false,
    useErrorBoundary: true,
    trpc: { context: { skipBatch: true } },
  });

  const handlePlatformSelect = (event: any, value: string) => {
    setSearchedPlatform(value);
  };

  return (
    <>
      <Box
        sx={{ mt: 4 }}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <FormControl style={{ margin: 0, width: "100%" }}>
          <TextField
            sx={{ pl: 0 }}
            size="small"
            id="user-search-input"
            placeholder="Username"
            variant="outlined"
            onChange={(event) => setSearchedUsername(event.target.value)}
          />
        </FormControl>
        {platforms && (
          <Autocomplete //Should make this a separate component for reuse in Explorer filters
            id="platforms"
            options={["All", ...platforms]}
            value={searchedPlatform}
            onInputChange={handlePlatformSelect}
            size="small"
            sx={{ width: "100%", ml: 2 }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={!searchedPlatform ? "Platform" : null}
              />
            )}
          />
        )}
        <Button
          variant="outlined"
          sx={{ ml: 2 }}
          href={
            searchedPlatform !== "All"
              ? `/user-search?username=${searchedUsername}&platform=${searchedPlatform}`
              : `/user-search?username=${searchedUsername}`
          }
          disabled={searchedUsername ? false : true}
        >
          Go
        </Button>
      </Box>
    </>
  );
};
